var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 0C19.252 0 0 19.252 0 43s19.252 43 43 43 43-19.252 43-43C85.973 19.263 66.737.027 43 0zm0 81C22.013 81 5 63.987 5 43S22.013 5 43 5s38 17.013 38 38c-.024 20.977-17.023 37.976-38 38z",
    fill: "#007179",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#007179",
    fill: "#007179",
    x: 21.5,
    y: 26.5,
    width: 43,
    height: 33,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 54V31l16.137 12.88a3 3 0 0 0 3.744 0L61 31v23a2 2 0 0 1-2 2H27a2 2 0 0 1-2-2z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 30 43.916 40.093a1.5 1.5 0 0 1-1.832 0L29 30h28z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8bbee3a3fd93c131f0217bb599cd0a16.svg";
export { ForwardRef as ReactComponent };